class CareersDetailsModel {
	id;
	title;
	description;
	image;
	title2;
	description2;
	slug;


	constructor({
		_id = '', title = '', description = '', image = '',
		slug = '', title2 = '', description2 = '',
	}) {
		this.id = _id;
		this.title = title;
		this.description = description;
		this.image = image;
		this.title2 = title2;
		this.description2 = description2;
		this.slug = slug;
	}
}

export default CareersDetailsModel;
